import React from "react";
import { Box } from "@intechprev/componentes-web";

export const LoadingComponent: React.FC = () => {
  return (
    <Box>
      <div style={{ "width": "100%", "display": "flex", "flexDirection": "column", "alignContent": "center", "justifyContent": "center" }}>
        <img style={{ width: 300, height: 200 }} src={"./imagens/loading.gif"} alt={"loading"} />

        <div>{"Carregando..."}</div>
      </div>
    </Box>
  );
};
